/* Reuse the installed GoCertify flow, with its real hosted page as fallback. */
(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-uk-key-worker]').forEach(function (link) {
      if (link.dataset.bound) return;
      link.dataset.bound = 'true';
      link.addEventListener('click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (window.gocertify && typeof window.gocertify.popup === 'function') {
          try {
            window.gocertify.popup();
            event.preventDefault();
          } catch (error) {
            // Leave native navigation to the provider's hosted eligibility page.
          }
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
